export default __webpack_public_path__ + "static/media/guarantor.5d282e29.svg";